import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Row, Col, CardHeader, Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListUl,
  faExternalLinkAlt,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { useJobDetails } from "../../../../providers/jobDetailsProvider";
import { utils } from "../../../../utils/utils";
import InformationModal from "../../../InformationModal";
import { sequenceApi } from "../../../../services/sequenceServices";

const PAGE_NUMBER = 0;
const PAGE_SIZE = 99999;

const DetailingSummary = () => {
  const [jobDetails] = useJobDetails();
  const { job } = jobDetails;
  const [informationModal, setInformationModal] = useState(
    utils.initInformationModal
  );
  const [sequence, setSequence] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(true);

  useEffect(() => {
    const fetchSequences = async () => {
      if (job) {
        try {
          const result = await sequenceApi.getAllSequences({
            jobId: job.id,
            page: PAGE_NUMBER,
            pageSize: PAGE_SIZE,
          });
          if (result.data && result.data.length > 0) {
            setSequence(result.data[result.data.length - 1]);
          }
        } catch (err) {
          setInformationModal({
            isOpen: true,
            title: "Error",
            body: "There was an error fetching the detailing data.",
            onClose: () =>
              setInformationModal({ ...utils.initInformationModal }),
          });
        }
      }
    };

    fetchSequences();
  }, [job]);

  if (!job) {
    return null;
  }

  const detailerName = sequence?.detailer?.firstName
    ? `${sequence.detailer.firstName} ${sequence.detailer.lastName || ""}`
    : "Not Assigned";
  const checkerName = sequence?.checker?.firstName
    ? `${sequence.checker.firstName} ${sequence.checker.lastName || ""}`
    : "Not Assigned";
  const status = sequence?.sequenceStatus?.description || "-";

  return (
    <Card className="m-0 p-3">
      <CardHeader className="bg-white border-0 p-0">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div className="rounded-circle d-flex align-items-center justify-content-center p-2 bg-soft-blue">
              <FontAwesomeIcon icon={faListUl} size="lg" />
            </div>
            <h4 className="mb-0 ml-3 font-weight-bold">Detailing</h4>
          </div>
          <div className="d-flex align-items-center">
            <Link
              to="/detailing/dashboard"
              className="text-dark"
              state={{ tab: utils.detailingTabs[sequence?.sequenceStatus?.id] }}
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} size="lg" />
            </Link>
            <button
              type="button"
              className="btn btn-link text-dark p-0 ml-3"
              onClick={() => setIsCollapsed((prev) => !prev)}
              aria-label={
                isCollapsed ? "Expand detailing" : "Collapse detailing"
              }
            >
              <FontAwesomeIcon
                icon={isCollapsed ? faChevronDown : faChevronUp}
                size="lg"
              />
            </button>
          </div>
        </div>
      </CardHeader>
      <Collapse isOpen={!isCollapsed}>
        <CardBody className="p-0 pt-3">
          <Row>
            <Col>
              <h4 className="font-weight-bold m-0 mb-1">{status}</h4>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <p className="text-muted mb-0">Detailer</p>
              <h6 className="m-0">{detailerName}</h6>
            </Col>
            <Col>
              <p className="text-muted mb-0">Checker</p>
              <h6 className="m-0">{checkerName}</h6>
            </Col>
          </Row>
        </CardBody>
      </Collapse>
      {informationModal.isOpen && (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={informationModal.onClose}
        />
      )}
    </Card>
  );
};

export default DetailingSummary;
